import { render, staticRenderFns } from "./DetailTambahProduct.vue?vue&type=template&id=7e97891a&scoped=true&"
import script from "./DetailTambahProduct.vue?vue&type=script&lang=js&"
export * from "./DetailTambahProduct.vue?vue&type=script&lang=js&"
import style0 from "./DetailTambahProduct.vue?vue&type=style&index=0&id=7e97891a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e97891a",
  null
  
)

export default component.exports